import { render, staticRenderFns } from "./TxnTable.vue?vue&type=template&id=5a48ddbc&scoped=true&"
import script from "./TxnTable.vue?vue&type=script&lang=js&"
export * from "./TxnTable.vue?vue&type=script&lang=js&"
import style0 from "./TxnTable.vue?vue&type=style&index=0&id=5a48ddbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48ddbc",
  null
  
)

export default component.exports